// extracted by mini-css-extract-plugin
export default {"form__select":"select_form__select__JvEBe"};